module.exports = __webpack_public_path__ + "static/media/10.e97c10a3.png";